import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { TCountryCodes } from '../models/country-code';
import { Genders, getAvailableGenders, TGender } from '../models/gender';

export const useGenderOptions = (countryCode?: TCountryCodes) => {
  const intl = useIntl();

  return useMemo(() => {
    const titles: Record<TGender, string> = {
      [Genders.Male]: intl.formatMessage({
        defaultMessage: 'Male',
        id: 'onboarding_gender_male',
        description: 'Gender select option',
      }),
      [Genders.Female]: intl.formatMessage({
        defaultMessage: 'Female',
        id: 'onboarding_gender_female',
        description: 'Gender select option',
      }),
      [Genders.Other]: intl.formatMessage({
        defaultMessage: 'Other',
        id: 'onboarding_gender_other',
        description: 'Gender select option for anything other than female or male',
      }),
    };

    return getAvailableGenders(countryCode).map(value => ({ title: titles[value], value }));
  }, [intl, countryCode]);
};
